<script setup lang="ts" name="ErrorNotAuthorized">
import BaseCardNotAuthorized from '~/components/BaseCardNotAuthorized.vue';
</script>

<template>
  <BaseCardNotAuthorized spacing="card-md" :button="null" />
</template>
